module.exports = __webpack_public_path__ + "img/numer_pin.71179056.png";